import { combineReducers } from '@reduxjs/toolkit';
import commonReducer from './utils/commonReducer';
import authReducer from './utils/authReducer';
import navReducer from './utils/navReducer';
import kitchenReducer from './utils/kitchenReducers/kitchenReducer';
import kitchenDashboardReducer from './utils/kitchenReducers/kitchenDashboardReducer';
import kitchenActsReducer from './utils/kitchenReducers/kitchenActsReducer';
import kitchenComplaintReducer from './utils/kitchenReducers/kitchenComplaintReducer';
import kitchenOrdersReducer from './utils/kitchenReducers/kitchenOrdersReducer';
import kitchenReviesReducer from './utils/kitchenReducers/kitchenReviewsReducer';
import kitchenProductsReducer from './utils/kitchenReducers/kitchenProductsReducer';
import kitchenMenuReducer from './utils/kitchenReducers/kitchenMenuReducer';
import kitchenSettingsReducer from './utils/kitchenReducers/kitchenSettingsReducer';
import deliveryServicesReducer from './utils/deliveryReducers/deliveryServicesReducer';
import deliveryMapReducer from './utils/deliveryReducers/deliveryMapReducer';
import deliveryCouriersPaymentsReducer from './utils/deliveryReducers/deliveryCouriersPaymentsReducer';
import deliveryMonitoringDocumentsReducer from './utils/deliveryReducers/deliveryMonitoringDocumentsReducer';
import deliveryAdminDocumentsReducer from './utils/deliveryReducers/deliveryAdminDocumentsReducer';
import clientsSearchReducer from './utils/clientsReducers/clientsSearchReducer';
import clientsNotificationsReducer from './utils/clientsReducers/clientsNotificationsReducer';
import addressesSearchReducer from './utils/clientsReducers/addressesSearchReducer';
import orderGroupsReducer from './utils/clientsReducers/orderGroupsReducer';
import financeWalletsReducer from './utils/financeReducers/financeWalletsReducer';
import financePromocodesReducer from './utils/financeReducers/financePromocodesReducer';
import financeCorpclientsReducer from './utils/financeReducers/financeCorpclientsReducer';
import accountingReportsReducer from './utils/accountingReducers/accountingReportsReducer';
import accountingKitchensPaymentsReducer from './utils/accountingReducers/accountingKitchensPaymentsReducer';
import moderationProductsReducer from './utils/moderationReducers/moderationProductsReducer';
import moderationReviewsReducer from './utils/moderationReducers/moderationReviewsReducer';
import settingsProfileReducer from './utils/settingsReducers/settingsProfileReducer';
import settingsCatalogsReducer from './utils/servicesReducers/settingsCatalogsReducer';
import servicesReducer from './utils/servicesReducers/servicesReducer';
import servicesAppsVersionsReducer from './utils/servicesReducers/servicesAppsVersionsReducer';
import servicesFileManagerReducer from './utils/servicesReducers/servicesFileManagerReducer';
import servicesLogsReducer from './utils/servicesReducers/servicesLogsReducer';
import servicesStoriesReducer from './utils/servicesReducers/servicesStoriesReducer';
import errorLogsReducer from './utils/errorLogsReducer';

const combineReducer = combineReducers({
  common: commonReducer,
  auth: authReducer,
  nav: navReducer,
  kitchen: kitchenReducer,
  kitchenDashboard: kitchenDashboardReducer,
  kitchenActs: kitchenActsReducer,
  kitchenComplaint: kitchenComplaintReducer,
  kitchenOrders: kitchenOrdersReducer,
  kitchenReviews: kitchenReviesReducer,
  kitchenMenu: kitchenMenuReducer,
  kitchenProducts: kitchenProductsReducer,
  kitchenSettings: kitchenSettingsReducer,
  deliveryServices: deliveryServicesReducer,
  deliveryMap: deliveryMapReducer,
  deliveryCouriersPayments: deliveryCouriersPaymentsReducer,
  deliveryMonitoringDocuments: deliveryMonitoringDocumentsReducer,
  deliveryAdminDocuments: deliveryAdminDocumentsReducer,
  clientsSearch: clientsSearchReducer,
  clientsNotifications: clientsNotificationsReducer,
  addressesSearch: addressesSearchReducer,
  orderGroups: orderGroupsReducer,
  financeWallets: financeWalletsReducer,
  financePromocodes: financePromocodesReducer,
  financeCorpclients: financeCorpclientsReducer,
  accountingReports: accountingReportsReducer,
  accountingKitchensPayments: accountingKitchensPaymentsReducer,
  moderationProducts: moderationProductsReducer,
  moderationReviews: moderationReviewsReducer,
  settingsProfile: settingsProfileReducer,
  settingsCatalogs: settingsCatalogsReducer,
  services: servicesReducer,
  servicesAppsVersions: servicesAppsVersionsReducer,
  servicesFileManager: servicesFileManagerReducer,
  servicesLogs: servicesLogsReducer,
  servicesStories: servicesStoriesReducer,
  errorLogs: errorLogsReducer,
});

export default combineReducer;
